import { router, usePathname } from 'expo-router'
import { LogIn } from 'lucide-react-native'
import { useCallback } from 'react'
import { StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { useAuth } from '@/lib/auth'
import { signInUrl } from '@/lib/auth-redirect'
import { Button } from '@/ui/Button'

export function AccessDeniedScreen() {
    const theme = useTheme()
    const pathname = usePathname()
    const { logout } = useAuth({ throwIfAnon: false })

    const handleReLogin = useCallback(() => {
        logout()
        router.replace(signInUrl(pathname) as '/')
    }, [logout, pathname])

    return (
        <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
            <LogIn size={48} color={theme.colors.primary} style={styles.icon} />
            <Text
                variant="headlineMedium"
                style={[styles.title, { color: theme.colors.onBackground }]}
            >
                Session expired
            </Text>
            <Text
                variant="bodyMedium"
                style={[styles.message, { color: theme.colors.onSurfaceVariant }]}
            >
                Please sign in again to continue.
            </Text>
            <Button
                title="Sign in"
                mode="contained"
                onPress={handleReLogin}
                style={styles.button}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
    },
    icon: {
        marginBottom: 16,
    },
    title: {
        marginBottom: 12,
        textAlign: 'center',
    },
    message: {
        marginBottom: 20,
        textAlign: 'center',
    },
    button: {
        marginTop: 8,
    },
})
